import { SoftwareOnboardingMain } from 'src/components/SoftwareOnboarding';
import { EscrowPartyTypeEnum } from 'src/graphql/schema';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { MembersCard, PartyCard, PartyContextProvider } from 'src/containers/Escrow/Summary';
import { AppLinkBanner } from 'src/widgets/AppLinkBanner';

import { BasicsCard, TechnicalSettingsCard, AgreementSettingsCard } from './ui';

const Members = () => {
  const {
    softwareEscrow: { id, beneficiary, app },
  } = useSoftwareEscrow();

  if (app.owned) return null;

  return <MembersCard escrowId={id} beneficiaryId={beneficiary!.id} basePath="/software-escrows" />;
};

const SummaryPage = () => {
  const {
    softwareEscrow: { id, agreement, beneficiary, depositor, currentCompanyRole, startedBy, app, escrowInvitation },
  } = useSoftwareEscrow();

  const isInvitedParty = currentCompanyRole !== startedBy;
  const appName = app.name ?? 'Untitled Application';

  return (
    <SoftwareOnboardingMain
      subtitle="Review"
      title="We're ready to set up your escrow"
      description={`Review your selections to make sure everything looks good. We'll use these settings to generate your escrow agreement. When you click ${isInvitedParty ? 'Submit' : 'Generate'}, your configuration will be sent to us for review.`}
    >
      <div className="max-w-260 w-full mx-auto space-y-4">
        <AppLinkBanner
          app={app}
          title={`Protection linked to ${appName}`}
          description={`Everyone with access to ${appName} can see this protection. This link is permanent, so it can't be attached to a different application.`}
        />
        <BasicsCard />
        <Members />
        <PartyContextProvider
          type={EscrowPartyTypeEnum.Depositor}
          party={depositor}
          escrowId={id}
          agreementForm={agreement.agreementForm!}
          basePath="/software-escrows"
        >
          <PartyCard app={app} escrowInvitation={escrowInvitation} />
        </PartyContextProvider>
        <PartyContextProvider
          type={EscrowPartyTypeEnum.Beneficiary}
          party={beneficiary}
          escrowId={id}
          agreementForm={agreement.agreementForm!}
          basePath="/software-escrows"
        >
          <PartyCard app={app} escrowInvitation={escrowInvitation} />
        </PartyContextProvider>
        <TechnicalSettingsCard />
        <AgreementSettingsCard />
      </div>
    </SoftwareOnboardingMain>
  );
};

export default SummaryPage;
